
import React, { useState, useEffect } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

  const imgurl = `${process.env.REACT_APP_URL}/image/products`

const CarouselSlide = ({ slides, autoSlide = false, autoSlideInterval = 3000 }) => {
  const [curr, setCurr] = useState(0)

  const prev = () => setCurr((curr) => (curr === 0 ? slides.length - 1 : curr - 1));

  const next = () => setCurr((curr) => (curr === slides.length - 1 ? 0 : curr + 1));


  useEffect(() => {
      if (!autoSlide) return
      const slideInterval = setInterval(next, autoSlideInterval)
      return () => clearInterval(slideInterval)
  }, [])
 
  const Descpt = (de) => {
    // console.log(ss);
    const txt = de.de.split("-");
    // console.log(txt);
    return ( 
      <ul className={`list-inside list-disc p-4 text-xl text-slate-200`}>
        {txt.map((de,i) => (
          <li key={i} className="first:list-none first:mb-1 last:list-none last:px-2 last:mt-1">
              {de}
          </li>
        ))}
      </ul>
    )
  }
  // console.log(slides);
  return (
    <div className="flex flex-col mx-auto relative">

      <div className='flex overflow-hidden relative touch-auto'>
        {slides.map((s,i) =>
        <div key={i} className="flex flex-col min-w-full touch-auto gap-4 sm:flex-row justify-center transition-transform ease-out duration-1000" style={{ transform: `translateX(-${curr * 100}%)` }}>
          <img src={`${imgurl}/${s.img}`} alt="" className="w-96 aspect-square mx-auto rounded-xl" />
          <div className="flex-col mx-auto p-4 border-t-2 sm:border-t-0 sm:border-l-2">
            <span className="text-center text-2xl sm:text-4xl text-slate-200"> {s.name}</span>
            <Descpt de={s.description} />
            {/* <p className="text-lg">{s.description}</p> */}
          </div>
        </div>
        )}
      </div>
      
      <div className="relative top-2 flex items-center justify-center px-4 py-0 gap-6">
        <button onClick={prev} className='p-1 rounded-full shadow bg-white/80 text-gray-800 opacity-15 hover:bg-white hover:opacity-100'>
          <ChevronLeftIcon className="h-6 w-6 text-gray-500" />
        </button>
        <div className='flex items-end justify-center gap-2'>
            {slides.map((s, i) => (
              <button key={i} 
                className={`transition-all text-xs w-4 h-4 text-center bg-slate-400 rounded-full hover:bg-opacity-90 ${curr === i ? "text-white bg-opacity-100" : " text-slate-500 bg-opacity-15"}`} 
                onClick={() => setCurr((curr) => (i))}
              >
              {i+1}
              </button>
            ))}
        </div>
        <button onClick={next} className='p-1 rounded-full shadow bg-white/80 text-gray-800 opacity-15 hover:bg-white hover:opacity-100'>
          <ChevronRightIcon className="h-6 w-6 text-gray-500" />
        </button>
      </div>
    </div>

  )
}

export default CarouselSlide